import { useEffect, useState } from 'react';
import { SUMMARY_PERIODS } from '../../../../projects/ProjectsApi/projects.consts';
import useDefaultTeam from './useDefaultTeam';
import useDefaultPdtIteration from './useDefaultPdtIteration';
import useDefaultActiveIteration from './useDefaultActiveIteration';
import useDefaultTab from '../useDefaultTab';

const useInitialization = ({
  setSelectedTab,
  setSelectedTeam,
  setSelectedPdtIteration,
  setActiveIteration,
  setTrendDuration,
  activeIterations,
  pastIterations,
  pdtIterations,
  isIterationsFetchFinished
}) => {
  const [isTeamInit, setIsTeamInit] = useState(false);
  const [isIterationsInit, setIsIterationsInit] = useState(false);
  const isInitialized = isTeamInit && isIterationsInit;

  const defaultTeam = useDefaultTeam();
  const defaultPdtIteration = useDefaultPdtIteration({
    pastIterations,
    pdtIterations
  });
  const defaultActiveIteration = useDefaultActiveIteration({
    activeIterations
  });
  const defaultTab = useDefaultTab({ activeIterations, pastIterations });

  const initState = () => {
    setSelectedTeam(defaultTeam);
    setTrendDuration(SUMMARY_PERIODS.last_3_months);
    setIsTeamInit(true);
    setSelectedTab(defaultTab);

    if (!defaultTeam) {
      setIsIterationsInit(true);
    }
  };

  const initIterations = () => {
    if (!isIterationsFetchFinished) return;

    setSelectedTab(defaultTab);
    setActiveIteration(defaultActiveIteration);
    setSelectedPdtIteration(defaultPdtIteration);
    setIsIterationsInit(true);
  };

  useEffect(() => {
    if (!isTeamInit) {
      initState();
    }
  }, [isTeamInit]);

  useEffect(() => {
    if (isTeamInit && !isIterationsInit) {
      initIterations();
    }
  }, [isTeamInit, isIterationsInit, isIterationsFetchFinished]);

  return isInitialized;
};

export default useInitialization;
